import React from 'react';
import FooterOne from '../common/footer/FooterOne';
import HeaderOne from '../common/header/HeaderOne';
import SEO from '../common/SEO';
import BannerOne from '../component/banner/BannerOne';
import CounterUpOne from '../component/counterup/CounterUpOne';
import ProjectOne from '../component/project/ProjectOne';
import SectionTitle from '../elements/section-title/SectionTitle';
import AboutThree from '../component/about/AboutThree';
import ServiceProp from '../component/service/ServiceProp';
import ServiceData from "../data/service/ServiceMain.json";
import { slugify } from '../utils';

const allData = ServiceData;


const DigitalAgency = () => {
    const designData = allData.filter(data => slugify(data.cate ? data.cate : "") === "design");

    return (
        <>
        <SEO title="Home"/>
        {/* <ColorSwitcher /> */}
        <main className="main-wrapper">
            <HeaderOne />
            <BannerOne />
            <AboutThree />
          
            <div className="section section-padding" id="our_services">
                <div className="container">
                    <SectionTitle 
                        subtitle="Our Service"
                        title=""
                        description=""
                        textAlignment="heading-left"
                        textColor=""
                    />
                    <div className="row">
                        <ServiceProp colSize="col-lg-4 col-md-6" serviceStyle="service-style-2" serviceData={designData}/>
                    </div>
                </div>
            </div>

            <ProjectOne />
            <CounterUpOne />

            {/* <TestimonialOne /> */}
            {/* <div className="section bg-color-light section-padding">
                <div className="container">
                    <SectionTitle 
                        subtitle="Pricing Plan"
                        title="We’ve built solutions for..."
                        description="Flexible pricing options for freelancers
                        and design teams."
                        textAlignment=""
                        textColor=""
                    />
                    <PricingOne />
                </div>
                <ul className="list-unstyled shape-group-3">
                    <li className="shape shape-1"><img src={process.env.PUBLIC_URL + "/images/others/line-1.png"} alt="shape" /></li>
                    <li className="shape shape-2"><img src={process.env.PUBLIC_URL + "/images/others/bubble-4.png"} alt="shape" /></li>
                </ul>
            </div> */}
            {/* <BrandOne />
            <BlogOne /> */}
            {/* <CtaLayoutOne />  */}

            <FooterOne parentClass="" />
        </main>
        </>
    )
}

export default DigitalAgency;

